import { Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import ScrollToTop from "../ScrollToTop";
import { Box } from "@mui/material";
import {
  clearSession,
  getSession,
  handleError,
  requestSquematic,
} from "../constants/commonFunctionts";

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const session = getSession();

  const isAbove991px = useMediaQuery("(max-width:991px)");

  const isActive = (path) => location.pathname === path;

  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);
  const closeNavbar = () => setExpanded(false);

  const handleLogout = async () => {
    try {
      const res = await requestSquematic(
        "POST",
        "/api/resuelve/logout",
        {},
        session?.token
      );

      if (res && res.results) {
        clearSession();
        closeNavbar();
        navigate("/");
      } else if (res && res.errors) {
        throw new Error(res.errors);
      }
    } catch (error) {
      handleError("Error cerrando sesión", error);
    }
  };

  return (
    <Navbar
      expand="lg"
      id="customNavBar"
      expanded={expanded}
      style={{
        backgroundColor: "#1555fd",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 1000,
        padding: isAbove991px ? "0 40px 0 40px" : "0 80px 0 60px",
      }}
    >
      <ScrollToTop />
      <Navbar.Brand>
        <Link to="/">
          <Box sx={{ width: { xs: 45, md: 50 },margin: "10px 0px"}}>
            <Image
              src={require("../assets/image/logo.png")}
              alt="Logo de resuelve colombia"
              style={{ width: "100%", objectFit: "contain" }}
            />
          </Box>
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
      <Navbar.Collapse id="basic-navbar-nav" style={{ fontSize: 20 }}>
        <Nav
          className="me-auto"
          style={{
            display: "flex",
            justifyContent: "space-around",
            width: "90%",
          }}
        >
          <Nav.Link
            as={Link}
            to="/"
            className={isActive("/") ? "active-link" : ""}
            onClick={closeNavbar}
          >
            Inicio
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/subscriptions"
            className={isActive("/subscriptions") ? "active-link" : ""}
            onClick={closeNavbar}
          >
            Suscripciones
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/register"
            className={isActive("/register") ? "active-link" : ""}
            onClick={closeNavbar}
          >
            Regístrate
          </Nav.Link>
          <NavDropdown title="Nosotros" id="basic-nav-dropdown">
            <NavDropdown.Item
              as={Link}
              to="/organizational-culture"
              className={
                isActive("/organizational-culture") ? "active-link" : ""
              }
              onClick={closeNavbar}
            >
              Cultura Organizacional
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="/who-we-are"
              className={isActive("/who-we-are") ? "active-link" : ""}
              onClick={closeNavbar}
            >
              Quienes Somos
            </NavDropdown.Item>
          </NavDropdown>
          <Nav.Link
            as={Link}
            to="/pay-order"
            className={isActive("/pay-order") ? "active-link" : ""}
            onClick={closeNavbar}
          >
            Pagar suscripción
          </Nav.Link>
          {session && (
            <Nav.Link
              as={Link}
              to="/dashboard"
              className={isActive("/dashboard") ? "active-link" : ""}
              onClick={closeNavbar}
            >
              Panel
            </Nav.Link>
          )}
        </Nav>
        {session ? (
          <Link
            to="#"
            className="btnNavBar btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              handleLogout();
            }}
          >
            Cerrar sesión
          </Link>
        ) : (
          <Link
            to="/login"
            className="btnNavBar btn btn-primary"
            onClick={closeNavbar}
          >
            Iniciar sesión
          </Link>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
}
